import { once } from 'lodash';

import config from 'js/app/config';

import { LOCAL_STORAGE_ANON_PROFILE_KEY } from 'bundles/account-profile/common/constants';
import type { LearnerProfile } from 'bundles/account-profile/common/types';
import type { AnonProfileEntry, LocalStorageAnonProfile } from 'bundles/account-profile/common/types';
import localStorageEx from 'bundles/common/utils/localStorageEx';

import femaleStockPhoto1 from 'images/account-profile/anonymization/stockPhotoFemale1.png';
import femaleStockPhoto2 from 'images/account-profile/anonymization/stockPhotoFemale2.png';
import femaleStockPhoto3 from 'images/account-profile/anonymization/stockPhotoFemale3.png';
import femaleStockPhoto4 from 'images/account-profile/anonymization/stockPhotoFemale4.png';
import femaleStockPhoto5 from 'images/account-profile/anonymization/stockPhotoFemale5.png';
import femaleStockPhoto6 from 'images/account-profile/anonymization/stockPhotoFemale6.png';
import femaleStockPhoto7 from 'images/account-profile/anonymization/stockPhotoFemale7.png';
import femaleStockPhoto8 from 'images/account-profile/anonymization/stockPhotoFemale8.png';
import femaleStockPhoto9 from 'images/account-profile/anonymization/stockPhotoFemale9.png';
import femaleStockPhoto10 from 'images/account-profile/anonymization/stockPhotoFemale10.png';
import maleStockPhoto1 from 'images/account-profile/anonymization/stockPhotoMale1.png';
import maleStockPhoto2 from 'images/account-profile/anonymization/stockPhotoMale2.png';
import maleStockPhoto3 from 'images/account-profile/anonymization/stockPhotoMale3.png';
import maleStockPhoto4 from 'images/account-profile/anonymization/stockPhotoMale4.png';
import maleStockPhoto5 from 'images/account-profile/anonymization/stockPhotoMale5.png';
import maleStockPhoto6 from 'images/account-profile/anonymization/stockPhotoMale6.png';
import maleStockPhoto7 from 'images/account-profile/anonymization/stockPhotoMale7.png';
import maleStockPhoto8 from 'images/account-profile/anonymization/stockPhotoMale8.png';
import maleStockPhoto9 from 'images/account-profile/anonymization/stockPhotoMale9.png';
import maleStockPhoto10 from 'images/account-profile/anonymization/stockPhotoMale10.png';

import _t from 'i18n!nls/account-profile';

// This list is so long because the recruiting dashboard could potentially show 100 candidates at a time, so I want to make sure we have enough
// names in case someone demoing changes a filter.
export function getMockProfileNamesAndPhotos(): AnonProfileEntry[] {
  return [
    {
      fullName: 'Aarav Patel',
      photoUrl: maleStockPhoto1,
    },
    {
      fullName: 'Aarya Singh',
      photoUrl: femaleStockPhoto1,
    },
    {
      fullName: 'Advait Gupta',
      photoUrl: maleStockPhoto2,
    },
    {
      fullName: 'Aisha Khan',
      photoUrl: femaleStockPhoto2,
    },
    {
      fullName: 'Anika Desai',
      photoUrl: femaleStockPhoto3,
    },
    {
      fullName: 'Arjun Sharma',
      photoUrl: maleStockPhoto3,
    },
    {
      fullName: 'Avni Mehta',
      photoUrl: femaleStockPhoto4,
    },
    {
      fullName: 'Devansh Joshi',
      photoUrl: maleStockPhoto4,
    },
    {
      fullName: 'Esha Patel',
      photoUrl: femaleStockPhoto5,
    },
    {
      fullName: 'Gaurav Singh',
      photoUrl: maleStockPhoto5,
    },
    {
      fullName: 'Ishaan Gupta',
      photoUrl: maleStockPhoto6,
    },
    {
      fullName: 'Jhanvi Shah',
      photoUrl: femaleStockPhoto6,
    },
    {
      fullName: 'Kabir Patel',
      photoUrl: maleStockPhoto7,
    },
    {
      fullName: 'Kavya Mehta',
      photoUrl: femaleStockPhoto7,
    },
    {
      fullName: 'Kunal Sharma',
      photoUrl: maleStockPhoto8,
    },
    {
      fullName: 'Manya Singh',
      photoUrl: femaleStockPhoto8,
    },
    {
      fullName: 'Neha Patel',
      photoUrl: femaleStockPhoto9,
    },
    {
      fullName: 'Nikhil Gupta',
      photoUrl: maleStockPhoto9,
    },
    {
      fullName: 'Pranav Desai',
      photoUrl: maleStockPhoto10,
    },
    {
      fullName: 'Rhea Shah',
      photoUrl: femaleStockPhoto10,
    },
    {
      fullName: 'Rishabh Singh',
      photoUrl: maleStockPhoto1,
    },
    {
      fullName: 'Riya Patel',
      photoUrl: femaleStockPhoto1,
    },
    {
      fullName: 'Sahil Mehta',
      photoUrl: maleStockPhoto2,
    },
    {
      fullName: 'Sakshi Sharma',
      photoUrl: femaleStockPhoto2,
    },
    {
      fullName: 'Yuvraj Patel',
      photoUrl: maleStockPhoto3,
    },
    {
      fullName: 'Aaradhya Singh',
      photoUrl: femaleStockPhoto3,
    },
    {
      fullName: 'Abhi Desai',
      photoUrl: maleStockPhoto4,
    },
    {
      fullName: 'Aditi Patel',
      photoUrl: femaleStockPhoto4,
    },
    {
      fullName: 'Amit Shah',
      photoUrl: maleStockPhoto5,
    },
    {
      fullName: 'Anjali Gupta',
      photoUrl: femaleStockPhoto5,
    },
    {
      fullName: 'Arnav Mehta',
      photoUrl: maleStockPhoto6,
    },
    {
      fullName: 'Arya Sharma',
      photoUrl: femaleStockPhoto6,
    },
    {
      fullName: 'Chirag Patel',
      photoUrl: maleStockPhoto7,
    },
    {
      fullName: 'Deepa Singh',
      photoUrl: femaleStockPhoto7,
    },
    {
      fullName: 'Dhruv Desai',
      photoUrl: maleStockPhoto8,
    },
    {
      fullName: 'Dia Patel',
      photoUrl: femaleStockPhoto8,
    },
    {
      fullName: 'Divya Gupta',
      photoUrl: femaleStockPhoto9,
    },
    {
      fullName: 'Harsh Shah',
      photoUrl: maleStockPhoto9,
    },
    {
      fullName: 'Ishita Sharma',
      photoUrl: femaleStockPhoto10,
    },
    {
      fullName: 'Jatin Patel',
      photoUrl: maleStockPhoto10,
    },
    {
      fullName: 'Jiya Mehta',
      photoUrl: femaleStockPhoto1,
    },
    {
      fullName: 'Kabir Singh',
      photoUrl: maleStockPhoto1,
    },
    {
      fullName: 'Kavya Sharma',
      photoUrl: femaleStockPhoto2,
    },
    {
      fullName: 'Krishna Patel',
      photoUrl: maleStockPhoto2,
    },
    {
      fullName: 'Mihika Gupta',
      photoUrl: femaleStockPhoto3,
    },
    {
      fullName: 'Naman Shah',
      photoUrl: maleStockPhoto3,
    },
    {
      fullName: 'Navya Patel',
      photoUrl: femaleStockPhoto4,
    },
    {
      fullName: 'Raj Desai',
      photoUrl: maleStockPhoto4,
    },
    {
      fullName: 'Riya Singh',
      photoUrl: femaleStockPhoto5,
    },
    {
      fullName: 'Rohan Mehta',
      photoUrl: maleStockPhoto5,
    },
    {
      fullName: 'Aman Gupta',
      photoUrl: maleStockPhoto6,
    },
    {
      fullName: 'Ananya Patel',
      photoUrl: femaleStockPhoto6,
    },
    {
      fullName: 'Aryan Sharma',
      photoUrl: maleStockPhoto7,
    },
    {
      fullName: 'Avi Singh',
      photoUrl: maleStockPhoto8,
    },
    {
      fullName: 'Bhavya Patel',
      photoUrl: femaleStockPhoto7,
    },
    {
      fullName: 'Devika Gupta',
      photoUrl: femaleStockPhoto8,
    },
    {
      fullName: 'Dhruvi Mehta',
      photoUrl: femaleStockPhoto9,
    },
    {
      fullName: 'Gauri Shah',
      photoUrl: femaleStockPhoto10,
    },
    {
      fullName: 'Ishaq Khan',
      photoUrl: maleStockPhoto9,
    },
    {
      fullName: 'Jai Patel',
      photoUrl: maleStockPhoto10,
    },
    {
      fullName: 'Jhanavi Gupta',
      photoUrl: femaleStockPhoto1,
    },
    {
      fullName: 'Kabir Desai',
      photoUrl: maleStockPhoto1,
    },
    {
      fullName: 'Kavya Singh',
      photoUrl: femaleStockPhoto2,
    },
    {
      fullName: 'Manas Patel',
      photoUrl: maleStockPhoto2,
    },
    {
      fullName: 'Mehak Sharma',
      photoUrl: femaleStockPhoto3,
    },
    {
      fullName: 'Mihir Patel',
      photoUrl: maleStockPhoto3,
    },
    {
      fullName: 'Navya Singh',
      photoUrl: femaleStockPhoto4,
    },
    {
      fullName: 'Nikhil Shah',
      photoUrl: maleStockPhoto4,
    },
    {
      fullName: 'Prisha Patel',
      photoUrl: femaleStockPhoto5,
    },
    {
      fullName: 'Rajat Gupta',
      photoUrl: maleStockPhoto5,
    },
    {
      fullName: 'Ritika Mehta',
      photoUrl: femaleStockPhoto6,
    },
    {
      fullName: 'Rohan Sharma',
      photoUrl: maleStockPhoto6,
    },
    {
      fullName: 'Saanvi Patel',
      photoUrl: femaleStockPhoto7,
    },
    {
      fullName: 'Samar Singh',
      photoUrl: maleStockPhoto7,
    },
    {
      fullName: 'Tanisha Desai',
      photoUrl: femaleStockPhoto8,
    },
    {
      fullName: 'Aditi Chakraborty',
      photoUrl: femaleStockPhoto9,
    },
    {
      fullName: 'Alok Khanna',
      photoUrl: maleStockPhoto8,
    },
    {
      fullName: 'Anjali Nair',
      photoUrl: femaleStockPhoto10,
    },
    {
      fullName: 'Arjun Khatri',
      photoUrl: maleStockPhoto9,
    },
    {
      fullName: 'Asha Singh',
      photoUrl: femaleStockPhoto1,
    },
    {
      fullName: 'Avinash Gupta',
      photoUrl: maleStockPhoto10,
    },
    {
      fullName: 'Chitra Raghavan',
      photoUrl: femaleStockPhoto2,
    },
    {
      fullName: 'Gautam Sharma',
      photoUrl: maleStockPhoto1,
    },
    {
      fullName: 'Geeta Patel',
      photoUrl: femaleStockPhoto3,
    },
    {
      fullName: 'Hari Iyer',
      photoUrl: maleStockPhoto2,
    },
    {
      fullName: 'Indira Rao',
      photoUrl: femaleStockPhoto4,
    },
    {
      fullName: 'Jayant Kumar',
      photoUrl: maleStockPhoto3,
    },
    {
      fullName: 'Kavita Patel',
      photoUrl: femaleStockPhoto5,
    },
    {
      fullName: 'Krishna Singh',
      photoUrl: maleStockPhoto4,
    },
    {
      fullName: 'Lakshmi Nair',
      photoUrl: femaleStockPhoto6,
    },
    {
      fullName: 'Manish Sharma',
      photoUrl: maleStockPhoto5,
    },
    {
      fullName: 'Meera Menon',
      photoUrl: femaleStockPhoto7,
    },
    {
      fullName: 'Nandita Chaudhary',
      photoUrl: femaleStockPhoto8,
    },
    {
      fullName: 'Navin Patel',
      photoUrl: maleStockPhoto6,
    },
    {
      fullName: 'Pranav Iyer',
      photoUrl: maleStockPhoto7,
    },
    {
      fullName: 'Priya Menon',
      photoUrl: femaleStockPhoto9,
    },
    {
      fullName: 'Rajiv Gupta',
      photoUrl: maleStockPhoto8,
    },
    {
      fullName: 'Rekha Sharma',
      photoUrl: femaleStockPhoto10,
    },
    {
      fullName: 'Sanjay Patel',
      photoUrl: maleStockPhoto9,
    },
    {
      fullName: 'Shalini Singh',
      photoUrl: femaleStockPhoto1,
    },
  ];
}

/**
 *
 * @param externalId - external id of the user whose data is stored in local storage; it is the <external_id> part in coursera.org/user/<external_id>
 * @param defaultFullName - the default name to use if there is no name saved in local storage for that id
 * @param defaultPhotoUrl - the default photo to use if there is no name saved in local storage for that id
 * @returns the full name and photo url either from local storage or from the provided defaults
 */
export function getLearnerDataFromLocalStorage(externalId: string, defaultFullName: string, defaultPhotoUrl: string) {
  const savedAnonymousData = localStorageEx?.getItem(
    LOCAL_STORAGE_ANON_PROFILE_KEY,
    JSON.parse,
    undefined
  ) as LocalStorageAnonProfile;
  let savedAnonymizedName = '';
  let savedAnonymizedPhotoUrl = '';

  if (savedAnonymousData?.[externalId]) {
    savedAnonymizedName = savedAnonymousData[externalId].fullName;
    savedAnonymizedPhotoUrl = savedAnonymousData[externalId].photoUrl;
  }

  return {
    fullName: savedAnonymizedName || defaultFullName,
    photoUrl: savedAnonymizedPhotoUrl || defaultPhotoUrl,
  };
}

export function getMemoizedRandomLearnerDataFn() {
  return once(() => {
    const mockNamesAndPhotos = getMockProfileNamesAndPhotos();
    const randomIndex = Math.floor(Math.random() * mockNamesAndPhotos.length);
    return mockNamesAndPhotos[randomIndex];
  });
}

export function saveLearnerDataToLocalStorage(newDataToSave: LocalStorageAnonProfile) {
  const savedAnonymousData = localStorageEx?.getItem(
    LOCAL_STORAGE_ANON_PROFILE_KEY,
    JSON.parse,
    undefined
  ) as LocalStorageAnonProfile;

  const newData = {
    ...savedAnonymousData,
    ...newDataToSave,
  };

  localStorageEx?.setItem(LOCAL_STORAGE_ANON_PROFILE_KEY, newData, JSON.stringify);
}

export function getAndSaveIndividualAnonLearnerData(
  learnerProfile: LearnerProfile,
  defaultAnonFullName: string,
  defaultAnonPhotoUrl: string
) {
  const { fullName, photoUrl } = getLearnerDataFromLocalStorage(
    learnerProfile.externalId,
    defaultAnonFullName,
    defaultAnonPhotoUrl
  );
  const profileWithAnonymizedData = {
    ...learnerProfile,
    fullName,
    profilePhoto: { default: photoUrl },
    about: _t(
      'My passion is solving problems and working collaboratively with others to make the world a better place. I have always enjoyed solving puzzles since I was young. Architecting components, wrestling with code, and analyzing datasets are uniquely interesting to me. I am always looking for opportunities to grow, and I am excited to put my skills to good use in whatever role I am in.'
    ),
    externalLinks: {
      // config.url.base will resolve to coursera.org in production
      default: config.url.base,
      linkedin: config.url.base,
      github: config.url.base,
      twitter: config.url.base,
      facebook: config.url.base,
    },
    resumeUrl: config.url.base,
  } as LearnerProfile;

  if (defaultAnonFullName === fullName) {
    const newData = {
      [learnerProfile.externalId]: {
        fullName,
        photoUrl,
      },
    };

    saveLearnerDataToLocalStorage(newData);
  }

  return profileWithAnonymizedData;
}
